const COMPANY_ID = 'parcdX'
const REVISION = '2026-07-15'
const EVENTS_URL = `https://a.klaviyo.com/client/events/?company_id=${COMPANY_ID}`
const PROFILES_URL = `https://a.klaviyo.com/client/profiles/?company_id=${COMPANY_ID}`
const SUBS_URL = `https://a.klaviyo.com/client/subscriptions/?company_id=${COMPANY_ID}`
const ORDER_ID_REQUIRED = ['irestore_website', 'amazon', 'ebay', 'walmart', 'costco', 'target']
const MONTHS = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
}

const PRODUCTS = {
  'ID-500': { name: 'iRESTORE Essential ID-500', legacy: 'iRestore Essential ID-500', months: 24 },
  'ID-505': {
    name: 'iRESTORE Professional ID-505',
    legacy: 'iRestore Professional ID-505',
    months: 24,
  },
  'ID-510': { name: 'iRESTORE Elite ID-510', legacy: 'iRestore Elite ID-510', months: 36 },
  'ID-500A': {
    name: 'iRESTORE Essential ID-500A (Battery Pack Kit)',
    legacy: 'iRestore Essential ID-500A (Battery Pack Kit)',
    months: 24,
  },
  'ID-505A': {
    name: 'iRESTORE Professional ID-505A (Battery Pack Kit)',
    legacy: 'iRestore Professional ID-505A (Battery Pack Kit)',
    months: 24,
  },
  'ID-510A': {
    name: 'iRESTORE Elite ID-510A (Battery Pack Kit)',
    legacy: 'iRestore Elite ID-510A (Battery Pack Kit)',
    months: 36,
  },
  'ID-610': {
    name: 'iRESTORE Illumina LED Face Mask ID-610',
    legacy: 'iRESTORE Illumina LED Face Mask ID-610',
    months: 12,
  },
  'ID-611': {
    name: 'iRESTORE Illumina LED Neck & Chest Mask ID-611',
    legacy: 'iRESTORE Illumina LED Neck & Chest Mask ID-611',
    months: 12,
  },
  'ID-612': {
    name: 'iRESTORE Illumina LED Eye Mask ID-612',
    legacy: 'iRESTORE Illumina LED Eye Mask ID-612',
    months: 12,
  },
  'ID-615': { name: 'Face Mask Pro ID-615', legacy: 'Face Mask Pro ID-615', months: 24 },
  'ID-PNL-1500': {
    name: 'Apex Pro 1500 ID-PNL-1500',
    legacy: 'Apex Pro 1500 ID-PNL-1500',
    months: 120,
  },
  'ID-PNL-2160': {
    name: 'Apex Elite 2160 ID-PNL-2160',
    legacy: 'Apex Elite 2160 ID-PNL-2160',
    months: 120,
  },
  'ID-700': { name: 'Flex LED Belt ID-700', legacy: 'Flex LED Belt ID-700', months: 12 },
  'ID-705': { name: 'Sculpt LED Belt ID-705', legacy: 'Sculpt LED Belt ID-705', months: 12 },
}

const PURCHASED_FROM = {
  irestore_website: 'iRestore Website',
  amazon: 'Amazon',
  ebay: 'eBay',
  walmart: 'Walmart',
  costco: 'Costco',
  target: 'Target',
  online_reseller: 'Online Reseller',
  doctors_office: "Doctor's Office",
  hair_salon: 'Hair Salon',
  medical_spa: 'Medical Spa',
  other: 'Other',
}

const HOW_HEARD = {
  good_morning_america: 'Good Morning America',
  online: 'Online',
  tv: 'TV',
  print: 'Print',
  radio: 'Radio',
  friends_family: 'Friends & Family',
  my_doctor: 'My Doctor',
  my_hair_dresser: 'My Hair Dresser',
  other: 'Other',
}

const HAIR_SERIAL_KEYS = {
  'ID-500': 'Serial Number - iRestore Essential ID-500',
  'ID-500A': 'Serial Number - iRestore Essential ID-500A',
  'ID-505': 'Serial Number - iRestore Professional ID-505',
  'ID-505A': 'Serial Number - iRestore Professional ID-505A',
  'ID-510': 'Serial Number - iRestore Elite ID-510',
  'ID-510A': 'Serial Number - iRestore Elite ID-510A',
}

const HAIR_ASIN_KEYS = {
  'ID-500': 'Amazon Purchased Product B01B29PCUU (ID-500)',
  'ID-500A': 'Amazon Purchased Product B01D3WXO4A (ID-500A)',
  'ID-505': 'Amazon Purchased Product B07M5X4D3P (ID-505)',
  'ID-505A': 'Amazon Purchased Product (ID-505A)',
  'ID-510': 'Amazon Purchased Product B0CC72B3FR (ID-510)',
  'ID-510A': 'Amazon Purchased Product B0CW4CLF2X (ID-510A)',
}

const SKIN_SERIAL_KEYS = {
  'ID-610': 'Serial Number - iRESTORE Illumina LED Face Mask ID-610',
  'ID-611': 'Serial Number - iRESTORE Illumina LED Neck & Chest Mask ID-611',
  'ID-612': 'Serial Number - iRESTORE Illumina LED Eye Mask ID-612',
}

const SKIN_ASIN_KEYS = {
  'ID-610': 'Amazon Purchased Product B0D7N2KWLH (ID-610)',
  'ID-611': 'Amazon Purchased Product B01D3WXO4A (ID-611)',
  'ID-612': 'Amazon Purchased Product B0D953MF72 (ID-612)',
  'ID-615': 'Amazon Purchased Product B0H5HS67KM (ID-615)',
}

const BODY_MODELS = ['ID-PNL-2160', 'ID-PNL-1500', 'ID-700', 'ID-705']
const BODY_ASIN_KEYS = {
  'ID-PNL-2160': 'Amazon Purchased Product B0GTX6Z24D (ID-PNL-2160)',
  'ID-PNL-1500': 'Amazon Purchased Product B0GTX19V9P (ID-PNL-1500)',
  'ID-700': 'Amazon Purchased Product B0FVJBDJR3 (ID-700)',
  'ID-705': 'Amazon Purchased Product B0G9CJJY1N (ID-705)',
}
const BODY_ORDER_KEYS = {
  'ID-PNL-2160': { shop: 'Order ID - ID-PNL-2160 - Shop', amazon: 'Order ID - ID-PNL-2160 - Amazon' },
  'ID-PNL-1500': { shop: 'Order ID - ID-PNL-1500 - Shop', amazon: 'Order ID - ID-PNL-1500 - Amazon' },
  'ID-700': { shop: 'Order ID - Flex Belt ID-700 - Shop', amazon: 'Order ID - Flex Belt ID-700 - Amazon' },
  'ID-705': { shop: 'Order ID - Sculpt Belt ID-705 - Shop', amazon: 'Order ID - Sculpt Belt ID-705 - Amazon' },
}

const AMZ_IMG =
  '<img src="https://cdn.shopify.com/s/files/1/1127/9482/files/amazon.png?1485808013256362334" alt="Amazon">'
const TP_IMG =
  '<img src="//www.irestorelaser.com/cdn/shop/files/trustpilot-badge_1024x1024.png?v=12276886535510140468" style="width: 100%; max-width: 240px; margin: 30px auto; display: block;" width="284" height="177" loading="lazy" alt="Trustpilot badge">'
const TP_IMG_WHITE =
  '<img src="https://cdn.shopify.com/s/files/1/1127/9482/files/trustpilot-badge-white.png?v=1777772573" style="width: 100%; max-width: 240px; margin: 30px auto; display: block;" width="284" height="177" loading="lazy" alt="Trustpilot badge">'
const COSTCO_IMG =
  '<img src="//www.irestorelaser.com/cdn/shop/files/costco-badge_1024x1024.png?v=7641084167320651184" style="width: 100%;" width="650" height="200" loading="lazy" alt="Costco badge">'

const HAIR_AMZ_US = {
  'ID-500': 'https://jo.my/amz-war-500-us-rev',
  'ID-500A': 'https://jo.my/amz-war-500a-us-rev',
  'ID-505': 'https://jo.my/amz-war-505-us-rev',
  'ID-505A': 'https://jo.my/amz-war-505a-us-rev',
  'ID-510': 'https://jo.my/amz-war-510-us-rev',
  'ID-510A': 'https://jo.my/amz-war-510a-us-rev',
}
const HAIR_AMZ_CA = {
  'ID-500': 'https://jo.my/amz-war-500-can-rev',
  'ID-500A': 'https://jo.my/amz-war-500-can-rev',
  'ID-505': 'https://jo.my/amz-war-505-can-rev',
  'ID-505A': 'https://jo.my/amz-war-505-can-rev',
  'ID-510': 'https://jo.my/amz-war-510-us-rev',
  'ID-510A': 'https://jo.my/amz-war-510a-us-rev',
}
const SKIN_AMZ = {
  'ID-610': 'https://jo.my/amz-war-610-us-rev',
  'ID-611': 'https://jo.my/amz-war-611-us-rev',
  'ID-612': 'https://jo.my/amz-warr-612-us-rev',
  'ID-615': 'https://jo.my/amz-warr-615-us-rev',
}
const BODY_AMZ = {
  'ID-PNL-1500': 'https://jo.my/amz-warr-pnl-1500-us-rev',
  'ID-PNL-2160': 'https://jo.my/amz-warr-pnl-2160-us-rev',
  'ID-700': 'https://jo.my/amz-warr-700-us-rev',
  'ID-705': 'https://jo.my/amz-warr-blt-705-us-rev',
}

const $ = (sel, root = document) => root.querySelector(sel)

function val(id) {
  return ($(`#${id}`)?.value || '').trim()
}

function selectedText(id) {
  const el = $(`#${id}`)
  if (!el || el.selectedIndex < 0) return ''
  return (el.options[el.selectedIndex].textContent || '').trim()
}

function omitEmpty(obj) {
  Object.keys(obj).forEach((k) => {
    if (obj[k] === '' || obj[k] == null || obj[k] === 'N/A') delete obj[k]
  })
  return obj
}

function validEmail(email) {
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return false
  const domain = email.split('@')[1]
  return domain !== 'example.com' && domain !== 'test.com'
}

function toE164(raw, countryEl) {
  const trimmed = (raw || '').trim()
  if (!trimmed) return null
  let digits = trimmed.replace(/[^\d+]/g, '')
  if (digits.startsWith('00')) digits = `+${digits.slice(2)}`
  if (digits.startsWith('+')) {
    const n = digits.replace(/\D/g, '')
    return n.length >= 8 && n.length <= 15 ? `+${n}` : null
  }
  const n = digits.replace(/\D/g, '')
  const opt = countryEl?.selectedOptions?.[0]
  const cc = opt?.dataset?.cc
  if (!cc || !n) return null
  if (cc === '1' && n.length === 10) return `+1${n}`
  if (n.startsWith(cc) && n.length >= 8 && n.length <= 15) return `+${n}`
  const combined = `${cc}${n}`
  return combined.length >= 8 && combined.length <= 15 ? `+${combined}` : null
}

function isoDate(monthName, day, year) {
  const m = MONTHS[monthName]
  const d = Number(day)
  const y = Number(year)
  if (!m || !d || !y) return null
  const dt = new Date(y, m - 1, d)
  if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return null
  return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`
}

function todayIso() {
  const n = new Date()
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}-${String(n.getDate()).padStart(2, '0')}`
}

function daysBetween(fromIso, toIso) {
  const a = new Date(`${fromIso}T00:00:00`)
  const b = new Date(`${toIso}T00:00:00`)
  return Math.round((b - a) / 86400000)
}

function canonicalSerial(raw) {
  return raw.replace(/[\s-]/g, '').toUpperCase()
}

function uniqueId(model, serial) {
  return `warranty-${model}-${serial}`
}

function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms))
}

async function postKlaviyo(url, body) {
  let last
  for (let i = 0; i < 3; i += 1) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { revision: REVISION, 'content-type': 'application/json' },
      body: JSON.stringify(body),
    })
    last = res
    if (res.status === 400) {
      console.error('Klaviyo 400', url, await res.text().catch(() => ''))
      return res
    }
    if (res.ok) return res
    if (res.status !== 429 && res.status < 500) return res
    await sleep(300 * 2 ** i)
  }
  return last
}

function identityProfile(n) {
  const loc = omitEmpty({
    address1: n.address,
    city: n.city,
    region: n.region,
    zip: n.zip,
    country: n.country,
  })
  const attrs = omitEmpty({
    email: n.email,
    phone_number: n.phone,
    first_name: n.firstName,
    last_name: n.lastName,
  })
  if (Object.keys(loc).length) attrs.location = loc
  return attrs
}

function buildLegacy(n) {
  const purchasedLabel = PURCHASED_FROM[n.purchasedFrom] || n.purchasedFrom
  const howLabel = HOW_HEARD[n.howHeard] || n.howHeard
  const props = omitEmpty({
    'First Name': n.firstName,
    'Last Name': n.lastName,
    'Phone Number': n.phone,
    'Registered Address': n.address,
    'Registered City': n.city,
    'Registered State/Province': n.region,
    'Registered State': n.regionCode || n.region,
    'Registered ZIP/Postal Code': n.zip,
    'Registered Country': n.country,
    Product: n.legacyProduct,
    'Purchased From': purchasedLabel,
    [`Purchased From ${purchasedLabel}`]: 'True',
    'Order ID': n.orderId,
    'Serial Number': n.serial,
    'Purchase Month': n.purchaseMonth,
    'Purchase Year': n.purchaseYear,
    'Purchadse Date': n.purchaseDate,
    'Birth Month': n.birthMonth,
    'Birth Year': n.birthYear,
    'Birth Date': n.birthday,
    Gender: n.gender,
    'How did you hear about us?': howLabel,
    'Please elaborate': n.howHeardOther,
  })

  if (n.category === 'hair') {
    const hairSerial = HAIR_SERIAL_KEYS[n.model]
    if (hairSerial) props[hairSerial] = n.serial
    if (n.purchasedFrom === 'amazon' && HAIR_ASIN_KEYS[n.model]) {
      props[HAIR_ASIN_KEYS[n.model]] = 'true'
    }
    if (n.purchasedFrom === 'costco' && n.model === 'ID-505') {
      props['Costco Purchased Product 1677269 (ID-505C-COS)'] = 'True'
    }
    if (n.surveyFamily) props['Q1: Anyone in your family suffer from hair loss?'] = n.surveyFamily
    if (n.surveyAge) props['Q2: What age did you start noticing hair loss?'] = n.surveyAge
    if (n.surveySpouse) props['Q5: Will your spouse also be using iRestore?'] = n.surveySpouse
    if (n.surveyTransplant) props['Q6: Have you ever had a hair transplant?'] = n.surveyTransplant
  }

  if (n.category === 'skin') {
    const skinSerial = SKIN_SERIAL_KEYS[n.model]
    if (skinSerial) props[skinSerial] = n.serial
    if (n.model === 'ID-615') {
      props[n.purchasedFrom === 'amazon' ? 'Serial Number - ID-615 - Amazon' : 'Serial Number - ID-615 - Shop'] =
        n.serial
    }
    if (n.purchasedFrom === 'amazon' && SKIN_ASIN_KEYS[n.model]) {
      props[SKIN_ASIN_KEYS[n.model]] = 'true'
    }
    const purchasedProductKey = n.model === 'ID-615' ? 'ID-615' : n.legacyProduct
    props[`Purchased Product ${purchasedProductKey}`] = 'True'
    if (n.purchasedFrom === 'amazon') props['Skin Device Owner - Amazon'] = 'True'
    else props['Skin Device Owner'] = 'True'
    if (n.model === 'ID-615' && n.orderId) {
      if (n.purchasedFrom === 'amazon') props['Order ID - Face Mask Pro ID-615 - Amazon'] = n.orderId
      else props['Order ID - ID-615 - Shop'] = n.orderId
    }
  }

  if (n.category === 'body') {
    const isAmz = n.purchasedFrom === 'amazon'
    if (n.model) {
      props[`Serial Number - ${n.model} - ${isAmz ? 'Amazon' : 'Shop'}`] = n.serial
      if (isAmz && BODY_ASIN_KEYS[n.model]) props[BODY_ASIN_KEYS[n.model]] = 'true'
      const orderKeys = BODY_ORDER_KEYS[n.model]
      if (n.orderId && orderKeys) props[isAmz ? orderKeys.amazon : orderKeys.shop] = n.orderId
    }
    props[`Purchased Product ${n.model}`] = 'True'
    if (isAmz) props['Body Device Owner - Amazon'] = 'True'
    else props['Body Device Owner'] = 'True'
  }

  return omitEmpty(props)
}

function customProfileProperties(n) {
  return omitEmpty(
    Object.assign(
      {
        warranty_registered: true,
        last_registered_product: n.productName,
        last_registered_device_category: n.category,
        last_registration_date: n.registrationDate,
        birthday: n.birthday,
        gender: n.gender,
      },
      buildLegacy(n)
    )
  )
}

function buildProfile(n) {
  const attrs = identityProfile(n)
  attrs.properties = customProfileProperties(n)
  return {
    data: {
      type: 'profile',
      attributes: attrs,
    },
  }
}

function buildEvent(n) {
  const profileAttrs = identityProfile(n)
  profileAttrs.properties = customProfileProperties(n)
  const properties = omitEmpty({
    device_category: n.category,
    product_name: n.productName,
    product_model: n.model,
    serial_number: n.serial,
    purchase_date: n.purchaseDate,
    registration_date: n.registrationDate,
    days_from_purchase_to_registration: n.daysFromPurchase,
    warranty_term_months: n.warrantyMonths,
    order_id: n.orderId,
    purchased_from: n.purchasedFrom,
    purchased_from_is_dtc: n.purchasedFrom === 'irestore_website',
    how_heard: n.howHeard,
    how_heard_other: n.howHeardOther,
    registration_source_page: n.sourcePage,
  })
  if (n.category === 'hair') {
    if (n.surveyFamily) properties.survey_family_hair_loss = n.surveyFamily
    if (n.surveyAge) properties.survey_age_first_noticed = n.surveyAge
    if (n.surveySpouse) properties.survey_spouse_will_use = n.surveySpouse
    if (n.surveyTransplant) properties.survey_had_transplant = n.surveyTransplant
  }
  return {
    data: {
      type: 'event',
      attributes: {
        metric: { data: { type: 'metric', attributes: { name: 'Registered Product' } } },
        profile: { data: { type: 'profile', attributes: profileAttrs } },
        time: new Date().toISOString(),
        unique_id: uniqueId(n.model, n.serial),
        properties,
      },
    },
  }
}

function buildSubscription(n) {
  const attrs = identityProfile(n)
  attrs.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } }
  return {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: 'Warranty Registration',
        profile: { data: { type: 'profile', attributes: attrs } },
      },
      relationships: { list: { data: { type: 'list', id: n.listId } } },
    },
  }
}

function reviewContent(n) {
  const amzStore = 'https://www.amazon.com/stores/iRestore+Hair+Growth+System/page/A9F28D55-5051-4383-A216-01E2F6F0EB56'
  if (n.category === 'hair') {
    if (n.purchasedFrom === 'amazon') {
      const map = n.country === 'Canada' ? HAIR_AMZ_CA : n.country === 'United States' ? HAIR_AMZ_US : null
      return {
        text: "Help others who are losing hair by leaving a quick review on Amazon. It's not required, but we would really appreciate it! Click the button below to leave a review",
        image: AMZ_IMG,
        url: (map && map[n.model]) || amzStore,
      }
    }
    if (n.purchasedFrom === 'costco') {
      return {
        text: "Help others who are losing hair by leaving a quick review on Costco. It's not required, but we would really appreciate it! Click the button below to leave a review",
        image: COSTCO_IMG,
        url: 'https://jo.my/costco-review-id505c',
      }
    }
    return {
      text: "Help others who are losing hair by leaving a quick review on Trustpilot. It's not required, but we would really appreciate it! Click the button below to leave a review",
      image: TP_IMG,
      url: 'https://jo.my/trust-pilot-review-id505',
    }
  }
  if (n.category === 'skin') {
    if (n.purchasedFrom === 'amazon') {
      return {
        text: "Help others transform their skin by leaving a quick review on Amazon. It's not required, but we would really appreciate it! Click the button below to leave a review",
        image: AMZ_IMG,
        url: SKIN_AMZ[n.model] || amzStore,
      }
    }
    return {
      text: "Help others transform their skin by leaving a quick review on Trustpilot. It's not required, but we would really appreciate it! Click the button below to leave a review",
      image: TP_IMG,
      url: 'https://jo.my/trust-pilot-review-id505',
    }
  }
  if (n.purchasedFrom === 'amazon') {
    return {
      text: "If you purchased on Amazon, help others by leaving a quick review. It's not required, but we would really appreciate it.",
      image: AMZ_IMG,
      url: BODY_AMZ[n.model] || 'https://jo.my/amz-warr-700-us-rev',
    }
  }
  return {
    text: "Help others by leaving a quick review on Trustpilot. It's not required, but we would really appreciate it.",
    image: TP_IMG_WHITE,
    url: 'https://jo.my/trust-pilot-review-body',
  }
}

function setFieldError(el, on, errorClass) {
  if (!el) return
  const tokens = errorClass.split(/\s+/).filter(Boolean)
  tokens.forEach((c) => el.classList.toggle(c, on))
  const trigger = el.closest('warranty-product-select')?.querySelector('[data-warranty-product-trigger]')
  if (trigger) tokens.forEach((c) => trigger.classList.toggle(c, on))
}

function collect(form) {
  const category = form.dataset.deviceCategory
  const model = val('productSelectedField')
  const product = PRODUCTS[model]
  const countryEl = $('#country')
  const email = val('email_subscribe').toLowerCase()
  const phone = toE164(val('klaviyo_form_phone_number'), countryEl)
  const birthday = isoDate(val('birth_month'), val('birth_date'), val('birth_year'))
  const purchaseDate = isoDate(val('purchase_month'), val('purchase_date'), val('purchase_year'))
  const registrationDate = todayIso()
  const country = val('country')
  const isUS = country === 'United States'
  const region = isUS ? selectedText('state') : val('state_input')
  const regionCode = isUS ? val('state') : val('state_input')
  return {
    category,
    listId: form.dataset.listId,
    sourcePage: form.dataset.sourcePage,
    firstName: val('klaviyo_form_first_name'),
    lastName: val('klaviyo_form_last_name'),
    email,
    phone,
    address: val('address'),
    city: val('city'),
    country,
    region,
    regionCode,
    zip: val('zip'),
    gender: val('gender'),
    birthMonth: val('birth_month'),
    birthYear: val('birth_year'),
    birthday,
    model,
    productName: product?.name,
    legacyProduct: product?.legacy,
    warrantyMonths: product?.months,
    purchasedFrom: val('purchasedFrom'),
    howHeard: val('how'),
    howHeardOther: val('how') === 'other' ? val('other_reason') : '',
    orderId: val('orderId'),
    purchaseMonth: val('purchase_month'),
    purchaseYear: val('purchase_year'),
    purchaseDate,
    daysFromPurchase: purchaseDate ? daysBetween(purchaseDate, registrationDate) : null,
    serial: canonicalSerial(val('serialnumber')),
    registrationDate,
    marketingOptIn: $('#marketing_opt_in')?.checked === true,
    surveyFamily: val('warranty-q1'),
    surveyAge: val('warranty-q2'),
    surveySpouse: val('warranty-q3'),
    surveyTransplant: val('warranty-q4'),
  }
}

function validate(form, n) {
  const errorClass = form.dataset.errorClass || '!bg-red/10 !border-red/30'
  const $empty = $('#empty_form_fields')
  const $invalidEmail = $('#invalid_email')
  const $invalidDate = $('#invalid_date')
  const $apiError = $('#klaviyo_api_error')
  const $box = $('#invalid_message')
  ;[$empty, $invalidEmail, $invalidDate, $apiError].forEach((el) => {
    if (el) el.style.display = 'none'
  })
  if ($box) $box.style.display = 'none'

  let empty = false
  let badEmail = false
  let badDate = false

  form.querySelectorAll('input[required], select[required]').forEach((el) => {
    const emptyVal = el.matches('input') ? !(el.value || '').trim() : !el.value
    const invalid = !el.checkValidity() || emptyVal
    setFieldError(el, invalid, errorClass)
    if (invalid) empty = true
  })

  const $email = $('#email_subscribe')
  if ($email && !validEmail(n.email)) {
    setFieldError($email, true, errorClass)
    badEmail = true
  }

  const $bm = $('#birth_month')
  const $bd = $('#birth_date')
  const $by = $('#birth_year')
  if (!n.birthday) {
    ;[$bm, $bd, $by].forEach((el) => setFieldError(el, true, errorClass))
    badDate = true
  }
  const $pm = $('#purchase_month')
  const $pd = $('#purchase_date')
  const $py = $('#purchase_year')
  if (!n.purchaseDate || n.purchaseDate > n.registrationDate) {
    ;[$pm, $pd, $py].forEach((el) => setFieldError(el, true, errorClass))
    badDate = true
  }
  if (!PRODUCTS[n.model]) {
    setFieldError($('#productSelectedField'), true, errorClass)
    empty = true
  }
  if (!n.serial) {
    setFieldError($('#serialnumber'), true, errorClass)
    empty = true
  }

  if (empty || badEmail || badDate) {
    if ($box) $box.style.display = 'block'
    if (empty && $empty) $empty.style.display = 'inline'
    if (badEmail && $invalidEmail) $invalidEmail.style.display = 'inline'
    if (badDate && $invalidDate) $invalidDate.style.display = 'inline'
    else if (badDate && $empty) $empty.style.display = 'inline'
    return false
  }
  return true
}

function syncStateFields() {
  const country = val('country')
  const $state = $('#state')
  const $stateInput = $('#state_input')
  if (!$state || !$stateInput) return
  const isUS = country === 'United States'
  $stateInput.parentElement.style.display = isUS || !country ? 'none' : 'block'
  $state.parentElement.style.display = isUS || !country ? 'block' : 'none'
  $stateInput.required = Boolean(country) && !isUS
  $state.required = !country || isUS
  $stateInput.disabled = isUS || !country
  $state.disabled = Boolean(country) && !isUS
}

function syncOther() {
  const $other = $('#other_reason')
  if (!$other) return
  const show = val('how') === 'other'
  $other.parentNode.style.display = show ? 'block' : 'none'
  $other.required = show
}

function syncOrderId() {
  const $order = $('#orderId')
  if (!$order) return
  $order.required = ORDER_ID_REQUIRED.includes(val('purchasedFrom'))
}

function syncSerialHint() {
  const $hint = $('#serial-format-hint')
  if (!$hint) return
  const model = val('productSelectedField')
  if (model === 'ID-700') {
    $hint.textContent =
      'Flex LED Belt serial is on the product box sleeve. Format: HY105B plus six characters (example: HY105B001244).'
  } else if (model === 'ID-705') {
    $hint.textContent =
      'Sculpt LED Belt serial is on the product box sleeve. Format: HY420 plus six characters (example: HY420001244).'
  } else if (model === 'ID-PNL-1500' || model === 'ID-PNL-2160') {
    $hint.textContent =
      'Apex panel serial format: six date digits, RDPRO, 1500 or 2160, three letters, then three to four digits (example: 260406RDPRO2160EZL001 or 260406RDPRO2160EZL0001).'
  } else {
    $hint.textContent = 'Select your product to see the serial number format.'
  }
}

function showSuccess(n) {
  const content = reviewContent(n)
  const $text = $('#review-site-text')
  const $img = $('#review-image')
  const $cta = $('#warranty-cta-btn')
  if ($text) $text.innerText = content.text
  if ($img) {
    $img.innerHTML = content.image
    $img.href = content.url
  }
  if ($cta) $cta.href = content.url
  $('#warranty-form')?.classList.add('hidden')
  $('#warranty-form-completed')?.classList.remove('hidden')
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

async function send(n) {
  const [eventRes, profileRes] = await Promise.all([
    postKlaviyo(EVENTS_URL, buildEvent(n)),
    postKlaviyo(PROFILES_URL, buildProfile(n)),
  ])
  if (!eventRes?.ok || !profileRes?.ok) return false
  if (!n.marketingOptIn) return true
  const subRes = await postKlaviyo(SUBS_URL, buildSubscription(n))
  return Boolean(subRes?.ok)
}

class WarrantyProductSelect extends HTMLElement {
  connectedCallback() {
    if (this._ready) return
    this.select = this.querySelector('#productSelectedField')
    this.fallback = this.querySelector('[data-warranty-product-fallback]')
    this.ui = this.querySelector('[data-warranty-product-ui]')
    this.trigger = this.querySelector('[data-warranty-product-trigger]')
    this.list = this.querySelector('[data-warranty-product-list]')
    this.preview = this.querySelector('[data-warranty-product-preview]')
    this.valueEl = this.querySelector('[data-warranty-product-value]')
    this.labelEl = this.querySelector('[data-warranty-product-label]')
    this.items = [...this.querySelectorAll('[role="option"]')]
    if (!this.select || !this.trigger || !this.list || !this.fallback || !this.ui) return
    this._ready = true

    this.select.tabIndex = -1
    this.select.setAttribute('aria-hidden', 'true')
    this.fallback.className = 'visually-hidden'
    this.ui.hidden = false
    this.matchHeight()
    this.onResize = () => this.matchHeight()
    window.addEventListener('resize', this.onResize)
    this.activeIndex = -1
    this.setListOpen(false)
    this.preloadImages()

    this.trigger.addEventListener('pointerdown', (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.toggle()
    })
    this.trigger.addEventListener('keydown', (e) => this.onTriggerKey(e))
    this.list.addEventListener('keydown', (e) => this.onListKey(e))
    this.items.forEach((item, index) => {
      item.tabIndex = -1
      item.addEventListener('click', (e) => {
        e.stopPropagation()
        this.choose(item.dataset.value)
      })
      item.addEventListener('mousemove', () => this.setActive(index, false))
    })
    this.onDocPointer = (e) => {
      if (!this.contains(e.target)) this.close()
    }
    document.addEventListener('pointerdown', this.onDocPointer)
    this.syncFromSelect()
  }

  disconnectedCallback() {
    document.removeEventListener('pointerdown', this.onDocPointer)
    window.removeEventListener('resize', this.onResize)
  }

  matchHeight() {
    const sample = document.querySelector('#purchasedFrom, #country, #gender')
    const h = sample?.getBoundingClientRect().height
    if (h) this.trigger.style.height = `${Math.round(h)}px`
  }

  get isOpen() {
    return this.dataset.open != null
  }

  toggle() {
    if (this.isOpen) this.close()
    else this.open()
  }

  preloadImages() {
    this.list.querySelectorAll('img').forEach((img) => {
      img.loading = 'eager'
      const pre = new Image()
      pre.decoding = 'async'
      pre.src = img.currentSrc || img.src
    })
  }

  setListOpen(open) {
    this.list.hidden = !open
    this.list.style.display = open ? 'block' : 'none'
    this.list.setAttribute('aria-hidden', open ? 'false' : 'true')
    this.list.inert = !open
    this.trigger.setAttribute('aria-expanded', open ? 'true' : 'false')
    this.floatLabel(open || Boolean(this.select.value))
  }

  floatLabel(on) {
    if (!this.labelEl) return
    this.labelEl.style.transform = on ? 'translateY(-0.875rem) scale(0.75)' : 'translateY(0) scale(1)'
  }

  open() {
    this.dataset.open = ''
    this.setListOpen(true)
    const selected = this.items.findIndex((item) => item.dataset.value === this.select.value)
    this.setActive(selected >= 0 ? selected : 0, true)
  }

  close() {
    delete this.dataset.open
    this.setListOpen(false)
    this.trigger.removeAttribute('aria-activedescendant')
    this.items.forEach((item) => item.removeAttribute('data-active'))
    this.activeIndex = -1
  }

  setActive(index, scroll) {
    if (!this.items.length) return
    const next = Math.max(0, Math.min(this.items.length - 1, index))
    this.activeIndex = next
    const dark = this.dataset.theme === 'dark'
    this.items.forEach((item, i) => {
      item.toggleAttribute('data-active', i === next)
      item.style.backgroundColor = i === next ? (dark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)') : ''
    })
    const active = this.items[next]
    this.trigger.setAttribute('aria-activedescendant', active.id)
    if (scroll) {
      const top = active.offsetTop - this.list.clientHeight / 2 + active.offsetHeight / 2
      this.list.scrollTop = Math.max(0, top)
    }
  }

  choose(value) {
    if (!value) return
    this.select.value = value
    this.select.dispatchEvent(new Event('change', { bubbles: true }))
    this.syncFromSelect()
    this.close()
    this.trigger.focus()
  }

  syncFromSelect() {
    const value = this.select.value
    const item = this.items.find((el) => el.dataset.value === value)
    this.items.forEach((el) => {
      el.setAttribute('aria-selected', el === item ? 'true' : 'false')
    })
    this.preview.replaceChildren()
    if (item) {
      const img = item.querySelector('img')
      if (img) {
        const thumb = img.cloneNode(true)
        thumb.removeAttribute('width')
        thumb.removeAttribute('height')
        thumb.className = ''
        thumb.style.cssText = 'display:block;width:20px;height:20px;object-fit:contain'
        this.preview.append(thumb)
      }
      this.preview.classList.toggle('hidden', !img)
      this.valueEl.textContent = item.dataset.label || ''
      this.dataset.filled = ''
      this.floatLabel(true)
    } else {
      this.preview.classList.add('hidden')
      this.valueEl.textContent = ''
      delete this.dataset.filled
      this.floatLabel(this.isOpen)
    }
  }

  onTriggerKey(e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      if (!this.isOpen) this.open()
      else if (e.key === 'Enter' || e.key === ' ') this.choose(this.items[this.activeIndex]?.dataset.value)
      else this.setActive(this.activeIndex + (e.key === 'ArrowDown' ? 1 : -1), true)
    } else if (e.key === 'Home') {
      e.preventDefault()
      if (!this.isOpen) this.open()
      this.setActive(0, true)
    } else if (e.key === 'End') {
      e.preventDefault()
      if (!this.isOpen) this.open()
      this.setActive(this.items.length - 1, true)
    } else if (e.key === 'Escape' && this.isOpen) {
      e.preventDefault()
      this.close()
    }
  }

  onListKey(e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault()
      this.setActive(this.activeIndex + (e.key === 'ArrowDown' ? 1 : -1), true)
    } else if (e.key === 'Home') {
      e.preventDefault()
      this.setActive(0, true)
    } else if (e.key === 'End') {
      e.preventDefault()
      this.setActive(this.items.length - 1, true)
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.choose(this.items[this.activeIndex]?.dataset.value)
    } else if (e.key === 'Escape') {
      e.preventDefault()
      this.close()
      this.trigger.focus()
    } else if (e.key === 'Tab') {
      this.close()
    }
  }
}

if (!customElements.get('warranty-product-select')) {
  customElements.define('warranty-product-select', WarrantyProductSelect)
}

function init() {
  const form = $('#warrantyRegistration')
  if (!form) return
  const errorClass = form.dataset.errorClass || '!bg-red/10 !border-red/30'
  syncStateFields()
  syncOther()
  syncOrderId()
  syncSerialHint()

  $('#country')?.addEventListener('change', syncStateFields)
  $('#how')?.addEventListener('change', syncOther)
  $('#purchasedFrom')?.addEventListener('change', syncOrderId)
  $('#productSelectedField')?.addEventListener('change', syncSerialHint)
  $('#where-it-is')?.addEventListener('click', (e) => {
    e.preventDefault()
    const hint = e.currentTarget.nextElementSibling
    if (hint) hint.classList.remove('hidden')
    syncSerialHint()
  })

  form.addEventListener('submit', async (e) => {
    e.preventDefault()
    syncOrderId()
    syncOther()
    const n = collect(form)
    if (!validate(form, n)) return
    const $btn = $('#signUp')
    if ($btn) $btn.disabled = true
    try {
      const ok = await send(n)
      if (ok) {
        showSuccess(n)
        return
      }
      const $box = $('#invalid_message')
      const $api = $('#klaviyo_api_error')
      if ($box) $box.style.display = 'block'
      if ($api) $api.style.display = 'inline'
    } catch (err) {
      console.error(err)
      const $box = $('#invalid_message')
      const $api = $('#klaviyo_api_error')
      if ($box) $box.style.display = 'block'
      if ($api) $api.style.display = 'inline'
    } finally {
      if ($btn) $btn.disabled = false
    }
  })

  form.querySelectorAll('input, select').forEach((el) => {
    el.addEventListener(el.tagName === 'SELECT' ? 'change' : 'input', () => {
      if (el.required) setFieldError(el, !(el.value || '').trim(), errorClass)
    })
  })
}

init()
